/**
 * DataLayer GA4 — eventos de interação.
 *
 * Escuta os eventos que o theme.js já dispara em vez de instrumentar cliques:
 *   ajaxProduct:added  → add_to_cart
 *   cart:updated       → remove_from_cart (quando a quantidade cai)
 *
 * O contexto de página (view_item, view_item_list, view_cart) vem do
 * snippets/datalayer.liquid, que tem acesso aos dados do Liquid.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function currency() {
    return (window.__snDL && window.__snDL.currency) || 'USD';
  }

  function push(event, ecommerce) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: event, ecommerce: ecommerce });
  }

  function lineToItem(line) {
    return {
      item_id: line.sku || String(line.variant_id || line.id),
      item_name: line.product_title || line.title,
      item_brand: line.vendor,
      item_variant: line.variant_title,
      price: (line.final_price != null ? line.final_price : line.price) / 100,
      quantity: line.quantity,
    };
  }

  /* Guarda o estado do carrinho para detectar remoção por diferença. */
  var snapshot = {};

  function snap(cart) {
    var next = {};
    (cart.items || []).forEach(function (l) {
      next[l.key || l.variant_id] = l;
    });
    return next;
  }

  function diffRemoved(prev, next) {
    var removed = [];
    Object.keys(prev).forEach(function (k) {
      var before = prev[k];
      var after = next[k];
      if (!after) {
        removed.push(lineToItem(before));
      } else if (after.quantity < before.quantity) {
        var item = lineToItem(before);
        item.quantity = before.quantity - after.quantity;
        removed.push(item);
      }
    });
    return removed;
  }

  /* --- add_to_cart --------------------------------------------------- */
  document.addEventListener('ajaxProduct:added', function (evt) {
    var d = evt.detail || {};
    var line = d.product || d.item || d;
    if (!line || (!line.variant_id && !line.id)) return;

    var item = lineToItem(line);
    push('add_to_cart', {
      currency: currency(),
      value: item.price * (item.quantity || 1),
      items: [item],
    });
  });

  /* O tema também dispara no próprio form; capturamos na fase de bolha. */
  document.addEventListener(
    'ajaxProduct:added',
    function () {},
    true
  );

  /* --- remove_from_cart ---------------------------------------------- */
  document.addEventListener('cart:updated', function (evt) {
    var cart = (evt.detail && (evt.detail.cart || evt.detail)) || null;
    if (!cart || !cart.items) return;

    var next = snap(cart);
    var removed = diffRemoved(snapshot, next);
    snapshot = next;

    if (removed.length) {
      push('remove_from_cart', {
        currency: currency(),
        value: removed.reduce(function (s, i) {
          return s + i.price * i.quantity;
        }, 0),
        items: removed,
      });
    }
  });

  /* --- begin_checkout ------------------------------------------------- */
  document.addEventListener(
    'click',
    function (evt) {
      var el = evt.target.closest(
        'button[name="checkout"], a[href$="/checkout"], input[name="checkout"]'
      );
      if (!el) return;
      push('begin_checkout', { currency: currency() });
    },
    true
  );

  /* --- select_item ---------------------------------------------------- */
  document.addEventListener(
    'click',
    function (evt) {
      var link = evt.target.closest('.grid-item__link, .grid-product__link');
      if (!link) return;
      var card = link.closest('[data-product-handle], .grid__item');
      var title = card && card.querySelector('.grid-product__title');
      if (!title) return;
      push('select_item', {
        items: [{ item_name: title.textContent.trim() }],
      });
    },
    true
  );

  /* Estado inicial do carrinho, para o primeiro diff ser correto. */
  if (window.theme && theme.cart && theme.cart.getCart) {
    theme.cart
      .getCart()
      .then(function (cart) {
        snapshot = snap(cart);
      })
      .catch(function () {});
  }
})();
